import React, { useEffect, useRef, useState } from "react"
import ToggleButton, { TToggleButtonProps } from "./ToggleButton"
import GMenu, { IMenuProps } from "../menu/GMenu"
import { MenuProps } from "@mui/material"
import Hamburger from "../icons/Hamburger"

export type TToggleMenuProps = {
    open?: boolean
    onOpen?: Function
    buttonProps? : Omit<TToggleButtonProps, "children">
    menuProps : Omit<IMenuProps, "open">
    children?: React.ReactElement|React.ReactElement[]
    onToggle?: (e:any,open:boolean) => void
    hideWidth? : number     // if window width>hideWidth, close menu
}

export const TopRightAnchor : Partial<MenuProps> = {anchorOrigin:{vertical:"bottom",horizontal:"right"},transformOrigin:{vertical:"top",horizontal:"right"}}
export default function MenuButton(props:TToggleMenuProps) {
    const {open:isOpen,buttonProps,menuProps,children} = props
    const [open,setOpen] = useState<boolean>(isOpen||false)
    const ref = useRef<any>(null)
    const onToggle = (e:any,open:boolean) => {
        setOpen(open)
        props.onToggle?.(e,open)
    }
    
    const onResize = () => {
        if (!props.hideWidth) return
        else if (window.innerWidth>props.hideWidth) onToggle(null, false)
    }
    useEffect(() => {if (isOpen!=open) setOpen(isOpen||false)},[isOpen])
    
    useEffect(() => {
        window.addEventListener("resize", onResize)
        return () => {window.removeEventListener("resize", onResize)}
    })
    return <>
        <ToggleButton {...buttonProps} ref={ref} onToggle={onToggle} open={open}>{children || <Hamburger/>}</ToggleButton>
        <GMenu {...menuProps} open={open} onClose={() => setOpen(false)} anchorEl={ref.current}/>
    </>
}